import React, { useState } from "react";
import styled from "styled-components";

const categories = [
  {
    img: "./Category/corporate.jpg",
    title: "Corporate",
    description: "Professional business storytelling",
  },
  {
    img: "./Category/resort.jpg",
    title: "Resort Productions",
    description: "Captivating luxury resort visuals",
  },
  {
    img: "./Category/estate.jpg",
    title: "Real Estate",
    description: "High-impact property showcases",
  },
  {
    img: "./Category/documentaries.jpg",
    title: "Documentaries",
    description: "Compelling narrative-driven films",
  },
  {
    img: "./Home/05.jpg",
    title: "Destination Promotions",
    description: "Inspiring travel destination highlights",
  },
  {
    img: "./Category/sport.jpg",
    title: "Action Sports",
    description: "Adrenaline-fueled sports cinematography",
  },
  {
    img: "./Category/commercial.jpg",
    title: "Product Commercials",
    description: "Creative product-focused advertising.",
  },
  {
    img: "./Category/arial.jpg",
    title: "Aerial Cinematography",
    description: "Stunning drone-captured perspectives",
  },
];

// Styled components
const ShowcaseContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px;
`;

const ImageList = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  @media (max-width: 600px) {
    flex-direction: column; /* Stack items vertically */
    align-items: center; /* Center items horizontally */
  }
`;

const ImageItem = styled.div`
  position: relative;
  margin: 5px;
  width: calc(50% - 10px); /* 3 items per row on larger screens */

  @media (max-width: 900px) {
    width: calc(50% - 10px); /* 2 items per row for medium screens */
    margin-bottom:2vh;
  }

  @media (max-width: 600px) {
    margin-bottom:2vh;
    width: 100%; /* Full width on mobile */
  }

  img {
    width: 100%;
    height: auto;
    display: block; /* Ensure image is a block element */
  }
`;

const ItemBar = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: ${(props) => (props.hovered ? "rgba(0, 0, 0, 0.7)" : "transparent")};
  color: white;
  padding: 10px;
  transition: background 0.3s ease;
  p{
    font-size:12px;
  }
`;

export default function ProjectShowcase() {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    <ShowcaseContainer>
      <ImageList>
        {categories.map((category, index) => (
          <ImageItem
            key={category.img}
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            <img
              srcSet={`${category.img}?w=248&fit=crop&auto=format&dpr=2 2x`}
              src={`${category.img}?w=248&fit=crop&auto=format`}
              alt={category.title}
              loading="lazy"
            />
            <ItemBar hovered={hoveredIndex === index}>
              <h4>{category.title}</h4>
              <p>{category.description}</p>
            </ItemBar>
          </ImageItem>
        ))}
      </ImageList>
    </ShowcaseContainer>
  );
}
